import { useLocation } from 'react-router-dom';
import { CommunityNoticeRouter } from '../../../../util/RouterUtil';
import ViewWrapper from '../../../ViewWrapper';

const CommunityNoticeRouterView = () => {
    const pathname = useLocation().pathname;
    return <ViewWrapper router={CommunityNoticeRouter} />;
};

export default CommunityNoticeRouterView;
